/**
 * ResourceFactory creates cancelable resources.
 * Work based on: http://stackoverflow.com/a/25448672/1677187
 * which is based on: https://developer.rackspace.com/blog/cancelling-ajax-requests-in-angularjs-applications/
 */
/* global array */
angular.module('core')
  .factory('cancelableResourceFactory', ['$q', '$resource', '$cachedResource', '$log', function($q, $resource, $cachedResource, $log) {

    /**
     * Wraps $resource and $cachedResource to allow cancelable api calls.
     */

    // Problem:
    // https://github.com/angular/angular.js/issues/9332
    // https://github.com/angular/angular.js/pull/12657/commits

    // Solution:
    // http://stackoverflow.com/questions/21666960/how-to-cancel-resource-requests#answer-25448672

    function abortablePromiseWrap(promise, deferred, outstanding) {
      promise.then(function () {
        deferred.resolve.apply(deferred, arguments);
      });

      promise.catch(function () {
        deferred.reject.apply(deferred, arguments);
      });
      /**
       * Remove from the outstanding array
       * on abort when deferred is rejected
       * and/or promise is resolved/rejected.
       */
      deferred.promise.finally(function () {
        array.remove(outstanding, deferred);
      });
      outstanding.push(deferred);
    }


    /**
     *
     * @param key: set to null for $resource, pass a string if you want to use $cachedResource
     * @param url: URL for Angular $resource
     * @param options: Options associated with Angular $resource
     * @param actions: Actions associated with Angular $resource 'get', 'post', 'query', etc...
     * @returns A resource with a cancelable promise
     */
    function createCacheableResource(key, url, options, actions) {
      var resource;
      var outstanding = [];
      actions = actions || {};

      Object.keys(actions).forEach(function (action) {
        var canceller = $q.defer();
        actions[action].timeout = canceller.promise;
        actions[action].Canceller = canceller;
      });

      /**
       * Intercept transformResponse: check http status first. If the status is not 2xx, then
       * bypass the subsequent transform, otherwise apiError returned might be trashed by the transform
       * functions.
       */
      _.each(actions, function (action) {
        if (_.isFunction(action.transformResponse)) {
          var transformer = action.transformResponse;
          action.transformResponse = function (body, headersGetter, status) {
            if (status >= 300) {
              try {
                if (body) {
                  return JSON.parse(body);
                }
              } catch(e) {
                console.error("Response could not be parsed. " + e);
              }
              return body;
            }
            else {
              return transformer(body, headersGetter, status);
            }
          };
        }
      });

      /**
       * Checks for explicit null key to determine whether or not to use $resource or $cachedResource
       */
      if(key === null) {
        resource = $resource(url, options, actions);
      } else {
        resource = $cachedResource(key, url, options, actions);
      }

      Object.keys(actions).forEach(function (action) {
        var method = resource[action];

        resource[action] = function () {
          var deferred = $q.defer(),
          promise = method.apply(null, arguments).$promise;

          abortablePromiseWrap(promise, deferred, outstanding);

          return {
            $promise: deferred.promise,

            abort: function () {
              deferred.reject('Aborted');
            },
            cancel: function () {
              //$log.info('cancel', actions[action]);

              actions[action].Canceller.resolve("Call cancelled");

              // Recreate canceler so that request can be executed again
              var canceller = $q.defer();
              actions[action].timeout = canceller.promise;
              actions[action].Canceller = canceller;
            }
          };
        };
      });

      /**
       * Abort all the outstanding requests on
       * this $resource. Calls promise.reject() on outstanding [].
       */
      resource.abortAll = function () {
        for (var i = 0; i < outstanding.length; i++) {
          outstanding[i].reject('Aborted all');
        }
        outstanding = [];
      };

      return resource;
    }

    return {
      createCacheableResource: function (key, url, options, actions) {
        return createCacheableResource(key, url, options, actions);
      }
    };
  }]);
